import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

export function getStaffInitials(fullName = '') {
  const parts = String(fullName)
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (parts.length === 0) {
    return '?';
  }

  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

const StaffAvatar = ({ avatarUrl, fullName, size = 40, sx = {} }) => {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [avatarUrl]);

  const initials = getStaffInitials(fullName);
  const hasImage = Boolean(avatarUrl) && !imageFailed;
  const safeName = typeof fullName === 'string' && fullName.trim() ? fullName.trim() : 'staff member';

  return (
    <Box
      sx={{
        width: size,
        height: size,
        minWidth: size,
        borderRadius: '50%',
        overflow: 'hidden',
        display: 'grid',
        placeItems: 'center',
        border: '1px solid',
        borderColor: 'divider',
        background: (theme) => theme.palette.mode === 'dark'
          ? 'linear-gradient(135deg, rgba(75, 85, 99, 0.85), rgba(17, 24, 39, 0.95))'
          : 'linear-gradient(135deg, rgba(214, 223, 235, 0.95), rgba(240, 244, 248, 1))',
        color: 'text.primary',
        flexShrink: 0,
        ...sx,
      }}
    >
      {hasImage ? (
        <Box
          component="img"
          src={avatarUrl}
          alt={`Profile image for ${safeName}`}
          loading="lazy"
          decoding="async"
          onError={() => setImageFailed(true)}
          sx={{
            width: '100%',
            height: '100%',
            display: 'block',
            objectFit: 'cover',
          }}
        />
      ) : (
        <Box
          role="img"
          aria-label={initials}
          sx={{
            width: '100%',
            height: '100%',
            display: 'grid',
            placeItems: 'center',
          }}
        >
          <Typography
            component="span"
            sx={{
              fontSize: Math.max(12, size * 0.36),
              lineHeight: 1,
              fontWeight: 800,
              letterSpacing: '0.04em',
            }}
          >
            {initials}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default StaffAvatar;
